import { useState, useEffect } from "react";
import { Users, ShoppingCart } from "lucide-react";
import api from "@/lib/api";
import AdminLayout from "@/components/AdminLayout";

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/users")
      .then((r) => setUsers(r.data))
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  return (
    <AdminLayout>
      <div data-testid="admin-users-page">
        <h1 className="text-2xl font-black admin-text mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Users</h1>
        <p className="text-xs text-slate-500 mb-4">{users.length} registered users</p>

        {loading ? (
          <div className="text-slate-400 py-8">Loading...</div>
        ) : (
          <div className="space-y-2" data-testid="users-list">
            {users.map((user) => (
              <div key={user.id} className="bg-white p-4 flex items-center gap-3">
                <div className="w-10 h-10 bg-[#0284C7] text-white flex items-center justify-center text-sm font-bold flex-shrink-0">
                  {(user.name || "U").charAt(0).toUpperCase()}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-bold text-slate-900">{user.name || "—"}</p>
                  <p className="text-xs text-slate-500">{user.email}</p>
                  <p className="text-xs text-slate-400">{user.phone || "No phone"}</p>
                </div>
                <span className={`text-[10px] font-bold uppercase px-2 py-1 ${
                  user.role === "admin" ? "bg-amber-100 text-amber-700" : "bg-slate-100 text-slate-500"
                }`}>
                  {user.role}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </AdminLayout>
  );
}
